<template>
  <section
    id="OnlineChatPage"
  >
    <div>
      <breadcrumb-mobile
        ref="header"
        @on-change-page="changePage"
      />
    </div>
    <b-card
      style="background-color: unset !important;"
      :dir="$functions.currentLangDirection()"
    >
      <iframe
        src="https://www.goftino.com/c/LwPRnQ"
        width="100%"
        height="600"
        frameborder="0"
        style="border: none;"
      />
    </b-card>
  </section>
</template>

<script>

import {
  BCard,
} from 'bootstrap-vue'
import BreadcrumbMobile from '@/layouts/breadcrumb.vue'
// eslint-disable-next-line import/no-cycle
import router from '@/router'

export default {
  components: {
    BreadcrumbMobile,
    BCard,
  },
  mounted() {
    this.$refs.header.getTitle('گفتگوی آنلاین')
  },
  methods: {
    changePage() {
      router.replace({ name: 'home' })
    },
  },
}
</script>

<style>
#OnlineChatPage {
  height: 100%;
}
iframe {
  width: 100%;
  height: calc(100vh - 200px);
  border: none;
}
@media (max-width: 768px) {
  #OnlineChatPage {
    margin: -28px;
  }
  #OnlineChatPage .card {
    height: calc(100vh - 150px);
    top: -53px;
  }
  iframe {
    height: calc(100vh - 250px);
  }
}
@media (min-width: 768px) {
  #OnlineChatPage {
    background-color: #fff !important;
    width: 800px;
    margin: 0 auto;
  }
}
</style>
